<template>
  <div class="loginModal" v-if="isShow">
    <div class="loginBox">
      <div class="header">
        <span>登&nbsp;&nbsp;录</span>
        <a-icon @click="$emit('closemodal')" class="close" type="close" />
      </div>
      <div class="content">
        <eform
          :formData="formData"
          class="loginform"
          ref="form"
          :fields="fields"
          v-if="fields || isRemind"
        >
          <div slot="account">
            <a-input
              class="inputbox"
              v-decorator="[
                'account',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入手机号/身份证号/平台账号',
                    },
                  ],
                },
              ]"
              placeholder="请输入手机号/身份证号/平台账号"
            >
              <div slot="prefix">
                <img src="../../assets/login/name.png" alt="" />
              </div>
            </a-input>
          </div>
          <div slot="password">
            <a-input
              class="inputbox"
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: '请输入8-16位密码，区分大小写' },
                  ],
                },
              ]"
              type="password"
              placeholder="请输入8-16位密码，区分大小写"
            >
              <div slot="prefix">
                <img src="../../assets/login/mima.png" alt="" />
              </div>
            </a-input>
          </div>
        </eform>
        <a-button type="primary" @click="handleSubmit"> 登录 </a-button>
        <div class="rem">
          <ul>
            <li>
              <input type="checkbox" v-model="checked" /><span>记住我</span>
            </li>
            <li @click="$emit('forget')">忘记密码</li>
          </ul>
          <span class="reg" @click="$emit('goregister')"
            >没有账号？去注册&gt;</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../units/cookie.js";
import { userLoginApi } from "@/request/api";
import { mapState } from "vuex"; //可以辅助获取到多个state的值
// import {mapMutations} from "vuex"
import eform from "@/components/common/form";
export default {
  name: "loginModal",
  props: { isShow: Boolean, exitshow: Boolean },
  components: { eform },
  computed: mapState({
    isLogin: (state) => state.isLogin,
    role: (state) => state.role,
    userId: (state) => state.userId,
    username: (state) => state.username,
    icon: (state) => state.icon,
  }),
  watch: {
    isShow: function () {
      this.fields = null;
      this.checked = false;
      if (getCookie("username")) {
        this.checked = true;
        this.fields = {
          account: getCookie("username"),
          password: getCookie("userpwd"),
        };
      }
    },
  },
  sockets: {
    login() {
      console.log("登录");
      // login 登录后发送 userId
      // logout 退出登录后发送
    },
  },
  data() {
    const formData = [
      {
        // label: "真实姓名",
        scopedSlots: { customRender: "account" },
      },
      {
        // label: "身份证号",
        scopedSlots: { customRender: "password" },
      },
    ];
    return {
      form: this.$form.createForm(this, { name: "horizontal_login" }),
      checked: false,
      password: "",
      formData,
      fields: null,
      isRemind: true,
    };
  },
  mounted() {
    window.addEventListener("keydown", this.enterClick, false);
  },
  destroyed() {
    window.removeEventListener("keydown", this.enterClick, false);
  },
  methods: {
    enterClick(e) {
      if (e.key === "Enter") {
        this.$refs.form.form.validateFields().then((res) => {
          // console.log(res)
          if (res.account && res.password) {
            this.getToken(
              userLoginApi,
              { account: res.account.trim(), password: res.password.trim() },
              (value) => {
                localStorage.setItem("isLogin", 0);
                localStorage.setItem("role", value.data.role);
                localStorage.setItem("username", value.data.name);
                localStorage.setItem("userId", value.data.id);
                localStorage.setItem("icon", value.data.icon);
                localStorage.setItem("token", value.data.token);
                localStorage.setItem("authentation", value.data.authentation);
                localStorage.setItem("loginTime", new Date().getTime());
                this.$store.commit("toggleIsLogin", {
                  isLogin: 0,
                  role: value.data.role,
                  userId: value.data.id,
                  username: value.data.name,
                  icon: value.data.icon,
                  authentation: value.data.authentation,
                  token: value.data.token,
                });

                this.$socket.emit("login", {
                  userId: value.data.id,
                  role: value.data.role,
                });
                this.$message.success("登录成功");

                let arr = window.location.pathname.split("/");
                if (
                  arr[arr.length - 1] == "register" ||
                  arr[arr.length - 1] == "forgetModal"
                ) {
                  this.$router.push({ path: "/" });
                }
                this.$emit("logined");
                if (value.code == 200) {
                  //判断复选框是否被勾选 勾选则调用配置cookie方法
                  if (this.checked == true) {
                    //传入账号名，密码，和保存天数3个参数
                    setCookie("username", res.account, 7);
                    setCookie("userpwd", res.password, 7);
                  } else {
                    //清空Cookie
                    setCookie("username", "", -1);
                    setCookie("userpwd", "", -1);
                  }
                }
              }
            );
          } else {
            this.$message.error("请输入账号和密码");
          }
        });
      }
    },
    handleSubmit() {
      this.$refs.form.form.validateFields().then((res) => {
        // console.log(res)
        if (res.account && res.password) {
          this.getToken(
            userLoginApi,
            { account: res.account.trim(), password: res.password.trim() },
            (value) => {
              localStorage.setItem("isLogin", 0);
              localStorage.setItem("role", value.data.role);
              localStorage.setItem("userId", value.data.id);
              localStorage.setItem("username", value.data.name);
              localStorage.setItem("icon", value.data.icon);
              localStorage.setItem("token", value.data.token);
              localStorage.setItem("authentation", value.data.authentation);
              localStorage.setItem("loginTime", new Date().getTime());
              this.$store.commit("toggleIsLogin", {
                isLogin: 0,
                role: value.data.role,
                userId: value.data.id,
                username: value.data.name,
                icon: value.data.icon,
                authentation: value.data.authentation,
              });
              this.$socket.emit("login", {
                userId: value.data.id,
                role: value.data.role,
              });

              this.$message.success("登录成功");
              let arr = window.location.pathname.split("/");
              if (
                arr[arr.length - 1] == "register" ||
                arr[arr.length - 1] == "forgetModal"
              ) {
                this.$router.push({ path: "/" });
              }
              // if(res.data.role=="学校"){
              //       if(arr[arr.length - 1]=='register'||arr[arr.length - 1]=='forgetModal'){
              //       this.$router.push({path:'/basicInfos'})
              //     }else{
              //           if(arr[arr.length - 1]=='register'||arr[arr.length - 1]=='forgetModal'){
              //           this.$router.push({path:'/basicInfo'})
              //         }
              //     }
              // }

              this.$emit("logined");
              if (value.code == 200) {
                //判断复选框是否被勾选 勾选则调用配置cookie方法
                if (this.checked == true) {
                  //传入账号名，密码，和保存天数3个参数
                  setCookie("username", res.account, 7);
                  setCookie("userpwd", res.password, 7);
                } else {
                  //清空Cookie
                  setCookie("username", "", -1);
                  setCookie("userpwd", "", -1);
                }
              }
            }
          );
        } else {
          this.$message.error("请输入账号和密码");
        }
      });
    },
  },
};
</script>


<style lang="stylus">
// .loginModal .ant-form-item-control {
//   position: relative;
//   line-height: 45px;
//   zoom: 1;
//   width: 360px;
//   height: 45px;
//   background-color: #ffffff;
//   border-radius: 3px;
// }

// .loginModal .ant-form-item-label {
//   display: none !important;
//   overflow: hidden;
//   line-height: 39.9999px;
//   white-space: nowrap;
//   text-align: right;
//   vertical-align: middle;
// }

.loginModal .ant-form-item-children .ant-input {
  display: block;
  width: 360px;
  height: 46px;
  border: 1px solid #c5cddb;
  padding-left: 40px;
}

// .loginModal .ant-input:focus {
//   border-color: #40a9ff;
//   border-right-width: 1px !important;
//   outline: 0;
//   -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.3);
//   box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.3);
// }

.loginform {
  width: 360px;
  margin: 0 atuo;

  .inputbox {
    width: 360px;
    height: 46px;
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #c5cddb;
  }

  .loginModal .loginBox .ant-input-affix-wrapper {
    line-height: 44px;
    height: 44px;
  }

  .ant-input-affix-wrapper .ant-input-prefix {
    left: 12px;
    font-size: 25px;
  }

  .ant-input-affix-wrapper .ant-input:not(:first-child) {
    padding-left: 40px;
    boder: none;
    border: none;
    width: 358px;
  }

  .ant-input-affix-wrapper .ant-input {
    height: 42px !important;
  }

  .ant-form-item-control {
    position: relative;
    zoom: 1;
    width: 360px;
  }
}
</style>
<style lang="stylus" scoped>
.loginModal {
  z-index: 999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.5);

  .loginBox {
    width: 440px;
    height: 365px;
    background-color: #ffffff;
    position: absolute;
    border-radius: 3px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .header {
      padding-top: 27px;
      padding-bottom: 20px;
      margin: 0 auto;
      overflow: hidden;
      text-align: center;

      span {
        color: #414141;
        font-size: 28px;
        display: inline-block;
      }

      .close {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #999;
        font-size: 25px;
        color: #d7d7d7;
      }
    }

    .content {
      height: 270px;
      padding-left: 40px;
      padding-right: 40px;

      .ant-btn-primary {
        height: 44px;
        width: 358px;
        background-color: #f0cd48;
        border-radius: 3px;
        font-size: 18px;
        border: 0;
        color: #333;
      }
    }

    .ant-input-affix-wrapper {
      line-height: 45px;
      height: 45px;

      .ant-input-prefix {
        font-size: 16px;
        top: 39px;
        position: relative;
      }
    }

    .rem {
      display: flex;
      margin-top: 10px;
      justify-content: space-between;
      font-size: 12px;
      align-items: center;
      color: #999;
      height: 32px;

      ul {
        display: flex;
        align-items: center;
        height: 100%;
        margin-bottom: 0px;

        li {
          display: flex;
          align-items: center;
          text-align: center;
          width: 80px;
          justify-content: center;
          cursor: pointer;
          border-right: 1px solid #ccc;

          input {
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: solid 1px #aaaaaa;
            margin-right: 8px;
            color: #f0cd48;
          }

          span {
            color: #999;
          }
        }

        li:last-child {
          border: 0;
        }

        li:hover {
          color: #ef9545;

          span {
            color: #ef9545;
          }
        }
      }

      .reg {
        color: #ef9545;
        cursor: pointer;
        height: 20px;
      }

      .reg:hover {
        border-bottom: solid 1px #ef9545;
      }
    }
  }
}
</style>
